var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Properties","page-icon":"mdi-office-building","collection-name":"property","items-per-page":20,"add-dialog-title":"Add Property","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }